// extracted by mini-css-extract-plugin
module.exports = {"procedure":"Procedure_procedure__04qHr","label":"Procedure_label__jhQCh","title":"Procedure_title__IAUUM"};